var HeroCarousel;
(function (HeroCarousel) {
    __once("search", () => {
        const $heroes = document.querySelectorAll('.hero-carousel.component');
        $heroes.forEach(($hero) => {
            var _a, _b;
            const $glide = $hero.querySelector('.glide');
            const $slides = $glide.querySelectorAll('.glide__slide');
            const $bullets = $glide.querySelector('.glide__bullets');
            const $bullet = $glide.querySelector('.glide__bullet');
            const glideController = new Glide($glide, {
                type: 'slider',
                focusAt: 'center',
                perView: 1,
                gap: 30,
                autoplay: false,
                animationDuration: 600,
                animationTimingFunc: 'linear',
                keyboard: true,
                rewind: false,
                breakpoints: {
                    800: {
                        perView: 1,
                        peek: {
                            before: 0,
                            after: 0
                        },
                    }
                }
            });
            $slides.forEach(($slide, index) => {
                const $navControl = $bullet.cloneNode(true);
                $navControl.setAttribute('data-glide-dir', `=${index}`);
                $navControl.classList.remove('hidden');
                $bullets.appendChild($navControl);
            });
            glideController.mount();
            glideController.pause();
            $hero['glideController'] = glideController;
            $hero.classList.add('is-initialized');
            (_a = $glide.querySelector('.glide__arrow--left')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-label', 'Scorri a sinistra');
            (_b = $glide.querySelector('.glide__arrow--right')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-label', 'Scorri a destra');
        });
    });
})(HeroCarousel || (HeroCarousel = {}));
